import React from 'react';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { InputField } from 'components/form';

import { LenderDeskingPanelFormValues } from '../../../types';

export const ConditionsSection = () => {
  const { control } = useFormContext<LenderDeskingPanelFormValues>();

  const { fields, append, remove } = useFieldArray({ control, name: 'conditions' });

  return (
    <Stack gap="0.75rem">
      {fields.map((field, index) => (
        <Box
          key={field.id}
          sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto', alignItems: 'center', gap: '0.75rem' }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ minWidth: '1.5rem', textAlign: 'right' }}>
            {index + 1}.
          </Typography>

          <InputField
            control={control}
            name={`conditions.${index}.value`}
            inputProps={{ size: 'small', variant: 'outlined', placeholder: 'Enter Condition', fullWidth: true }}
          />

          <IconButton size="small" onClick={() => remove(index)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}

      <Box>
        <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={() => append({ value: '' })}>
          Add Condition
        </Button>
      </Box>
    </Stack>
  );
};
